"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("../theme.scss");
var moment = require("moment");
var ui_1 = require("@vidazoo/ui");
var NotificationMessage = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationMessage, _super);
    function NotificationMessage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationMessage.prototype.renderError = function () {
        return (React.createElement("div", { className: theme.notificationEmpty },
            React.createElement(ui_1.PageMessage, { small: true, title: "No notification selected", description: "Please select a notification to continue...", iconName: "icon-warning" })));
    };
    NotificationMessage.prototype.render = function () {
        var selectedItem = this.props.selectedItem;
        var item = selectedItem;
        return (React.createElement(React.Fragment, null, item ?
            React.createElement("div", { className: theme.notificationMessage },
                React.createElement("div", { className: theme.top },
                    React.createElement("div", { className: theme.topText },
                        React.createElement("div", null,
                            React.createElement("div", { className: theme.author },
                                React.createElement("div", null,
                                    "App: ",
                                    item.app || "Vidazoo")),
                            React.createElement("div", { className: theme.date },
                                "Time: ",
                                moment(item.created).format("DD/MM/YYYY, HH:MM:SS"))),
                        React.createElement("div", null,
                            React.createElement("div", { className: theme.subject }, item.subject)))),
                React.createElement(ui_1.HLine, { topSpace: 1, bottomSpace: 2, type: "solid", style: { borderBottomColor: "var(--vidazoo-items-conatiner-background-color)" } }),
                React.createElement("div", { className: theme.bottom },
                    React.createElement("div", { className: theme.message, dangerouslySetInnerHTML: { __html: (item.params && item.params.htmlMessage) ? item.params.htmlMessage : item.message } })))
            : this.renderError()));
    };
    return NotificationMessage;
}(React.Component));
exports.default = NotificationMessage;
